const NotFound = () => {
  return <h1>Page Not found !</h1>
} 

export default NotFound;